// extracted by mini-css-extract-plugin
export default {"body":"EditShareProjectModal_body__YvNQh","inline":"EditShareProjectModal_inline__NPU2v","icon":"EditShareProjectModal_icon__GAmVN"};